
export default {
  name: 'YoutubeChannelBannerDownloader',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What should be on the YouTube banner?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "A YouTube banner should include elements representing your channel, such as your channel name, logo, imagery related to your content, and a visually appealing design that captures the viewers' attention."
          }
        },
        {
          "@type": "Question",
          "name": "What is the difference between YouTube channel art and a banner?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The terms 'YouTube channel art' and 'YouTube banner' are often used interchangeably. They both refer to the same thing: the visual header displayed at the top of a YouTube channel page."
          }
        },
        {
          "@type": "Question",
          "name": "What is the download YouTube channel banner size?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The recommended download size for a YouTube channel banner is 2560 pixels by 1440 pixels. This YouTube banner size download requirement ensures it will display properly on various devices and screen sizes."
          }
        },
        {
          "@type": "Question",
          "name": "What file type is a YouTube channel banner?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The file type for a YouTube channel banner is typically an image format like JPEG or PNG. Both are widely supported and offer good image quality."
          }
        },
        {
          "@type": "Question",
          "name": "Are there download restrictions on YouTube channel banner downloader?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "While these tools generally have no restriction on downloading the banners, we recommend respecting copyright rights. Also, ensure you have the necessary permissions or use these images for personal or non-commercial purposes."
          }
        }
      ]
    };
  },
  data () {
    return {
      data: '',
      form: this.$vform({
        url: null
      })
    }
  },
  methods: {
    YoutubeChannelBannerDownloader() {
        this.form.post(`/tool/youtube-channel-banner-downloader`, { progress: false }).then(res => {
          this.data = res.data;
        }).catch(e => {
          console.log(e);
        });
    },
    onSample(){
        this.form.url = 'https://www.youtube.com/@GoogleDevelopers';
    },
    onReset(){
        this.form.reset();
        this.data = null;
    }
  }
}
